import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap'

import LazyUserAddressPinpoint from 'domains/sales/users/organisms/lazy-user-address-pinpoint'

const SalesUsersAddressForm = ({
  address,
  index,
  canRemove,
  onChange,
  onRemove,
  onUndoRemove,

  pinpointOpen,
  onOpenPinpoint,
  onClosePinpoint,
  onSubmitCoordinates,
}) => {
  const removed = String(address?._destroy || '0') === '1'
  const set = (key, value) => onChange(index, { ...address, [key]: value })

  const hasCoordinates =
    address?.latitude !== null &&
    address?.latitude !== undefined &&
    address?.latitude !== '' &&
    address?.longitude !== null &&
    address?.longitude !== undefined &&
    address?.longitude !== ''

  return (
    <Card className="mt-3" style={{ opacity: removed ? 0.6 : 1 }}>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <div>
          <b>{address?.recipient_name?.trim() ? address.recipient_name : `Address #${index + 1}`}</b>
          {address?.id ? <span className="ml-2 text-muted">ID: {address.id}</span> : null}
          {removed ? <span className="ml-2 text-danger">(removed)</span> : null}
        </div>

        <div>
          {!removed && canRemove ? (
            <Button size="sm" color="danger" onClick={() => onRemove(index)}>
              Remove
            </Button>
          ) : null}

          {removed ? (
            <Button size="sm" color="secondary" onClick={() => onUndoRemove(index)}>
              Undo
            </Button>
          ) : null}
        </div>
      </CardHeader>

      <CardBody>
        <Row form>
          <Col md="6">
            <FormGroup>
              <Label>Recipient Name</Label>
              <Input
                disabled={removed}
                value={address.recipient_name || ''}
                onChange={(e) => set('recipient_name', e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col md="6">
            <FormGroup>
              <Label>Recipient Number</Label>
              <Input
                disabled={removed}
                value={address.recipient_number || ''}
                onChange={(e) => set('recipient_number', e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col md="12">
            <FormGroup>
              <Label>Complete Address</Label>
              <Input
                disabled={removed}
                value={address.complete_address || ''}
                onChange={(e) => set('complete_address', e.target.value)}
              />
            </FormGroup>
          </Col>

          <Col md="12">
            <FormGroup>
              <Label>Instruction</Label>
              <Input
                disabled={removed}
                value={address.instruction || ''}
                onChange={(e) => set('instruction', e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>

        <hr />

        <h5 className="mb-2">Pinpoint Google Map</h5>

        <Row form>
          <Col md="6">
            <FormGroup>
              <Label>Latitude</Label>
              <Input
                readOnly
                value={address.latitude ?? ''}
                placeholder="Belum dipilih"
              />
            </FormGroup>
          </Col>

          <Col md="6">
            <FormGroup>
              <Label>Longitude</Label>
              <Input
                readOnly
                value={address.longitude ?? ''}
                placeholder="Belum dipilih"
              />
            </FormGroup>
          </Col>
        </Row>

        <div className="d-flex flex-wrap align-items-center" style={{ gap: 8 }}>
          {!removed && !pinpointOpen ? (
            <Button size="sm" color="primary" onClick={onOpenPinpoint}>
              📍 Pinpoint Google Map
            </Button>
          ) : null}

          {!removed && pinpointOpen ? (
            <Button size="sm" color="secondary" onClick={onClosePinpoint}>
              Hide Map
            </Button>
          ) : null}

          {!removed && hasCoordinates ? (
            <Button
              size="sm"
              outline
              color="danger"
              onClick={() => onSubmitCoordinates({ latitude: null, longitude: null })}
            >
              Clear Coordinates
            </Button>
          ) : null}

          {hasCoordinates ? (
            <span className="text-success small">Coordinates saved</span>
          ) : (
            <span className="text-muted small">No coordinates yet</span>
          )}
        </div>

        {!removed && pinpointOpen ? (
          <div className="mt-3 border rounded p-2">
            <LazyUserAddressPinpoint
              fullAddress={address.complete_address}
              cityName={address.city_name}
              districtName={address.suburb_name || address.area_name}
              provinceName={address.province_name}
              lat={Number.isFinite(Number(address.latitude)) ? Number(address.latitude) : undefined}
              long={Number.isFinite(Number(address.longitude)) ? Number(address.longitude) : undefined}
              onSubmitCoordinates={onSubmitCoordinates}
              closePinpoint={onClosePinpoint}
            />
          </div>
        ) : null}
      </CardBody>
    </Card>
  )
}

SalesUsersAddressForm.propTypes = {
  address: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  canRemove: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onUndoRemove: PropTypes.func.isRequired,

  pinpointOpen: PropTypes.bool,
  onOpenPinpoint: PropTypes.func.isRequired,
  onClosePinpoint: PropTypes.func.isRequired,
  onSubmitCoordinates: PropTypes.func.isRequired,
}

export default SalesUsersAddressForm
